import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";

import {catchError, first, Observable, of, tap} from "rxjs";

import {Country, Language, TimeZone} from "../models";
import { ApiConfig } from "./api-config";
import {Currency} from "../models/currency";
import {environment} from "../../../environments/environment";
import {RecordCache} from '../helpers/records/record-cache';

type AutomationEntry = {
  label: string,
  value: string
}

export type AutomationAvailableSettings = {
  trigger_groups: {
    label: string,
    triggers: AutomationEntry[]
  }[],
  actions: AutomationEntry[]
}

@Injectable({
  providedIn: 'root'
})
export class DataService {

  private automationAvailableSettings: RecordCache<AutomationAvailableSettings, []> = new RecordCache();

  constructor(private http: HttpClient) { }

  //Fixme
  getCountries(): Observable<Country[]> {
    const url = ApiConfig.getApiUrl('/countries.json');
    return this.http.get<Country[]>(url)
      .pipe(
        tap(countries => console.log('DataService.getCountries() =>', countries)),
        catchError(this.handleError<any>('getCountries', []))
      );
  }

  getLanguages(): Observable<Language[]> {
    const url = ApiConfig.getApiUrl('/translations/languages.json');
    return this.http.get<Language[]>(url);
  }

  getTimeZones(): Observable<TimeZone[]> {
    const url = ApiConfig.getApiUrl('/translations/time-zones.json');
    return this.http.get<TimeZone[]>(url);
  }

  //Fixme
  getCurrencies(): Observable<Currency[]> {
    return this.http.get<Currency[]>('/currencies.json');
  }

  getAutomationAvailableSettings(): Observable<AutomationAvailableSettings> {
    const obs$ = this.http.get<AutomationAvailableSettings>(ApiConfig.getApiUrl('/automation.json'));
    return this.automationAvailableSettings.getOrSet(obs$).pipe(first((v) => !!v));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error); // log to console instead
      console.error(`${operation} failed: ${error.message}`);
      return of(result as T);
    };
  }

}
